export const GET_ALL_PLUS_CCTV_SECTIONS = "V3_GET_ALL_PLUS_CCTV_SECTIONS";
export const SET_SELECTED_PLUS_CCTV_SECTION = "V3_SET_SELECTED_PLUS_CCTV_SECTION";
export const UNSET_SELECTED_PLUS_CCTV_SECTION = "V3_UNSET_SELECTED_PLUS_CCTV_SECTION";